import { filtersConfiguration } from '@/config/rcm.js'

export const events = {
	UPLOAD_DOCUMENT_EVENT: 'UPLOAD_DOCUMENT_EVENT',
	REPLACE_DOCUMENT_EVENT: 'REPLACE_DOCUMENT_EVENT',
	DELETE_DOCUMENT_EVENT: 'DELETE_DOCUMENT_EVENT',
  VIEW_AGREEMENTS_EVENT: 'VIEW_AGREEMENTS_EVENT',
  MODIFY_AGREEMENTS_EVENT: 'MODIFY_AGREEMENTS_EVENT',
  MODIFY_PRE_AUDIT_COMMENTS_EVENT: 'MODIFY_PRE_AUDIT_COMMENTS_EVENT',
  MODIFY_CONCURRENT_AUDIT_COMMENTS_EVENT: 'MODIFY_CONCURRENT_AUDIT_COMMENTS_EVENT',
  COMPLETE_AUDIT_EVENT: 'COMPLETE_AUDIT_EVENT',
  PASS_TO_READY_TO_GENERATE_EVENT: 'PASS_TO_READY_TO_GENERATE_EVENT',
  PASS_MULTIPLE_ACCOUNTS_TO_READY_TO_GENERATE_EVENT: 'PASS_MULTIPLE_ACCOUNTS_TO_READY_TO_GENERATE_EVENT',
  VIEW_PRE_SETTLEMENTS_EVENT: 'VIEW_PRE_SETTLEMENTS_EVENT',
  MODIFY_PRE_SETTELEMENTS_EVENT: 'MODIFY_PRE_SETTELEMENTS_EVENT',
  VIEW_PRODUCT_CONFIGURATION_EVENT: 'VIEW_PRODUCT_CONFIGURATION_EVENT',
  MODIFY_PRODUCT_CONFIGURATION_EVENT: 'MODIFY_PRODUCT_CONFIGURATION_EVENT',
  UPLOAD_AGREEMENT_MATRIX: 'UPLOAD_AGREEMENT_MATRIX',
  ASSIGN_RESPONSIBLE_EVENT: 'ASSIGN_RESPONSIBLE_EVENT',
  REPLACE_SUPPORT_DOCUMENT_IN_PRE_SETTLEMENTS_EVENT: 'REPLACE_SUPPORT_DOCUMENT_IN_PRE_SETTLEMENTS_EVENT',
}

export const agreementsRestrictions = {
  'EDITOR': [
    events.MODIFY_AGREEMENTS_EVENT,
    events.MODIFY_PRE_SETTELEMENTS_EVENT,
    events.MODIFY_PRODUCT_CONFIGURATION_EVENT,
    events.UPLOAD_AGREEMENT_MATRIX,
    events.COMPLETE_AUDIT_EVENT,
    events.ASSIGN_RESPONSIBLE_EVENT
  ],
  'EDITOR_WITH_AUDIT': [
    events.MODIFY_AGREEMENTS_EVENT,
    events.MODIFY_PRE_SETTELEMENTS_EVENT,
    events.MODIFY_PRODUCT_CONFIGURATION_EVENT,
    events.UPLOAD_AGREEMENT_MATRIX,
    events.REPLACE_SUPPORT_DOCUMENT_IN_PRE_SETTLEMENTS_EVENT
  ],
  'VIEWER': [
    events.VIEW_AGREEMENTS_EVENT,
    events.MODIFY_AGREEMENTS_EVENT,
    events.VIEW_PRE_SETTLEMENTS_EVENT,
    events.MODIFY_PRE_SETTELEMENTS_EVENT,
    events.VIEW_PRODUCT_CONFIGURATION_EVENT,
    events.MODIFY_PRODUCT_CONFIGURATION_EVENT,
    events.UPLOAD_AGREEMENT_MATRIX,
    events.PASS_MULTIPLE_ACCOUNTS_TO_READY_TO_GENERATE_EVENT,
    events.ASSIGN_RESPONSIBLE_EVENT,
    events.REPLACE_SUPPORT_DOCUMENT_IN_PRE_SETTLEMENTS_EVENT
  ],
  'INTERNAL_AUDITOR': [
    events.VIEW_AGREEMENTS_EVENT,
    events.MODIFY_AGREEMENTS_EVENT,
    events.VIEW_PRE_SETTLEMENTS_EVENT,
    events.MODIFY_PRE_SETTELEMENTS_EVENT,
    events.VIEW_PRODUCT_CONFIGURATION_EVENT,
    events.MODIFY_PRODUCT_CONFIGURATION_EVENT,
    events.UPLOAD_AGREEMENT_MATRIX,
    events.PASS_MULTIPLE_ACCOUNTS_TO_READY_TO_GENERATE_EVENT,
    events.COMPLETE_AUDIT_EVENT,
    events.REPLACE_SUPPORT_DOCUMENT_IN_PRE_SETTLEMENTS_EVENT
  ],
  'EXTERNAL_AUDITOR': [
    events.VIEW_AGREEMENTS_EVENT,
    events.MODIFY_AGREEMENTS_EVENT,
    events.VIEW_PRE_SETTLEMENTS_EVENT,
    events.MODIFY_PRE_SETTELEMENTS_EVENT,
    events.VIEW_PRODUCT_CONFIGURATION_EVENT,
    events.MODIFY_PRODUCT_CONFIGURATION_EVENT,
    events.UPLOAD_AGREEMENT_MATRIX,
    events.PASS_MULTIPLE_ACCOUNTS_TO_READY_TO_GENERATE_EVENT,
    events.COMPLETE_AUDIT_EVENT,
    events.REPLACE_SUPPORT_DOCUMENT_IN_PRE_SETTLEMENTS_EVENT
  ],
  'ADMIN': [
    events.UPLOAD_AGREEMENT_MATRIX,
  ],
  'CONSULTANT': [
    events.ASSIGN_RESPONSIBLE_EVENT
  ]
}

export const filterStatusByRoleStatusPermissions = (rolePermissionsStatuses) => {
	const statusFilter = filtersConfiguration.find((filterConfig) => filterConfig.category === 'rcm-status-account');

	const statusByRole = statusFilter.items.filter((statusFilter) => {
		const roleStatus = rolePermissionsStatuses.find((roleStatus) => roleStatus.status === statusFilter.value);

		if (roleStatus) {
			return statusFilter;
		}
	});

	const filteredStatusByRole = []

	if (statusByRole.length > 0) {
		//to avoid vuex warn mutation outside mutation handler we need to create a new object with the same structure
		filtersConfiguration.forEach((filterConfig) => {
			if(filterConfig.category === 'rcm-status-account') {
				filteredStatusByRole.push({...filterConfig, items: statusByRole});
			}else{
				filteredStatusByRole.push(filterConfig);
			}
		})

		return filteredStatusByRole;
	}

	return filtersConfiguration;
};

export const getAllowedEventsByRole = (roles, restrictedEvents) => {
  const rolesArray = Array.isArray(roles) ? roles : roles.split(',');
  const restrictedEventsArray = restrictedEvents ? restrictedEvents.map(event => event.restrictedEvent) : [];

  let allowedEvents = Object.keys(events);

  rolesArray.forEach(role => {
    const agreementRestrictions = agreementsRestrictions[role];

    if(agreementRestrictions && agreementRestrictions.length > 0) {
      allowedEvents = allowedEvents.filter(event => !agreementRestrictions.includes(event));
    }

    if(restrictedEventsArray.length > 0) {
      allowedEvents = allowedEvents.filter(event => !restrictedEventsArray.includes(event));
    }
  })

  return allowedEvents;
}
